module.exports = __webpack_public_path__ + "img/bernier.0974df8c.png";